import { global } from 'stylist'

export default ()=> global()



// WEBPACK FOOTER //
// ./src/styles/global.js